<template>
    <!-- <el-select
        clearable
        v-model="selected"
        @change="onChange"
        :popper-class="popperClass"
        :disabled="isDisable"
        :size="size"
    >
        <el-option
            v-for="lst in list"
            :label="lst.dictLabel"
            :value="!getLabel ? lst.dictValue : lst.dictLabel"
            :key="lst.dictCode"
        />
    </el-select> -->
    
    <van-popup v-model:show="showPicker" :close-on-click-overlay="false" position="bottom">
        <van-picker
            visible-item-count="3"
            :columns="list.map(v => v.dictLabel)"
            @confirm="onConfirm"
            @cancel="onCancel"
        />
    </van-popup>
</template>

<script>
export default {
    props: {
        // 类型编码
        typeCode: String,
        show: {
            type: Boolean,
            default: () => false
        },
        selectDict: {
            type: Function
        }
    },
    data() {
        return {
            showPicker: this.show,
            list: []
        }
    },
    mounted() {
        this.getList()
    },
    watch: {
        show () {
            this.showPicker = this.show
        }
    },
    methods: {
        // 查询字典列表
        getList() {
            // 不刷新的情况下只请求一次
            if (!window._dictionary) {
                window._dictionary = {}
            }
            if (window._dictionary[this.typeCode]) {
                this.list = window._dictionary[this.typeCode]
            } else {
                this.$baseApi.getDictData({
                    dictType: this.typeCode
                }).then(res => {
                    if (res.success) {
                        this.list = window._dictionary[this.typeCode] = res.data.list.sort((a, b) => a.id - b.id)
                    }
                })
            }
        },
        onConfirm (value) {
            this.selectDict && this.selectDict(this.list.find(v => v.dictLabel == value))
        },
        onCancel () {
            this.selectDict && this.selectDict(null)
            this.showPicker = false
        }
    }
}
</script>